/* eslint-disable react-hooks/exhaustive-deps */
import { GetServerSidePropsContext } from 'next'
import { useRouter } from 'next/router'
import React from 'react'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'

import { MainLayout } from 'src/features/layouts'
import { ProjectDetails } from 'src/features/projects'
import {
  projectKeys,
  projectsApi,
  useQueryProjectById
} from 'src/features/projects/common'
import { sharedApi, TRANSLATE } from '../../../shared'

export const getServerSideProps = async ({
  params,
  locale
}: GetServerSidePropsContext) => {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery(TRANSLATE, () =>
    sharedApi.getTranslate(locale)
  )
  const projectId = params?.projectId ? Number(params.projectId) : undefined

  if (projectId) {
    await queryClient.prefetchQuery(
      [projectKeys.detail(projectId), locale],
      () => projectsApi.getProjectById(projectId, locale ?? 'en')
    )
  }

  return {
    props: {
      locale: locale,
      dehydratedState: dehydrate(queryClient)
    }
  }
}

const ProjectPage = () => {
  const router = useRouter()
  const projectId = router.query.projectId
  const { data: project } = useQueryProjectById(Number(projectId))

  return project ? (
    <MainLayout
      title={project?.name}
      description={
        project.appointment
          ? project.appointment
              .replace(/(\<(\/?[^>]+)>)/g, '')
              .replace(/[&amp;nbsp;]/g, '')
          : ''
      }
      image={project?.cover}
      withFooter
      withoutSidebar
    >
      <ProjectDetails />
    </MainLayout>
  ) : null
}

export default ProjectPage
